import type { Discussion } from 'types/discussion'
import type { RightsSplitChain } from 'types/rights-data'

const NOTE_PREVIEW_MAX_CHARS = 100

export const getNotePreview = (rawText: string | null): string => {
  const text = (rawText ?? '').trim()
  return text.length > NOTE_PREVIEW_MAX_CHARS
    ? `${text.slice(0, NOTE_PREVIEW_MAX_CHARS)}…`
    : text
}

export const collectNoteIds = (
  discussions: Discussion[],
): Record<string, boolean> => {
  const ids: Record<string, boolean> = {}
  for (const d of discussions) {
    ids[String(d.id)] = true
    if (d.replies) {
      for (const reply of d.replies) {
        ids[String(reply.id)] = true
      }
    }
  }
  return ids
}

export const collectRightsSplitIds = (
  chains: RightsSplitChain[],
): Record<string, boolean> => {
  const ids: Record<string, boolean> = {}
  for (const chain of chains) {
    ids[String(chain.id)] = true
  }
  return ids
}

export const getRightsSplitText = (chain: RightsSplitChain): string => {
  const names = chain.members.map(m => m.entity.title).join(' + ')
  const pct =
    chain.rights_percentage != null
      ? `${(chain.rights_percentage / 100).toFixed(2)}%`
      : null
  if (names && pct) return `${names} — ${pct}`
  return names || pct || '—'
}
